import { Link } from 'react-router-dom';
import './AuthLayout.css';
import authImage from '.././assets/log_sign_image.png';
import overlayImage from '.././assets/ls_overlay.png';
import logo from '.././assets/logo.svg';

const AuthLayout = ({ children }) => {
  return (
    <div className="auth-layout">
      <div className="auth-layout__left">
        <img src={authImage} alt="" className="auth-layout__image" />
        <Link to="/">
          <img src={logo} alt="Winning Partner" className="auth-layout__logo" />
        </Link>
        <h1 className="auth-layout__title">Welcome to<br />Winning Partner!</h1>
      </div>
      <div className="auth-layout__right">
        <img src={overlayImage} alt="" className="auth-layout__overlay" />
        <div className="auth-layout__form-container">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
